import { ActionTree } from "vuex";
import { RootState } from "../types/RootState";
import { OnlineUsersState } from "../types/OnlineUsersState";

import { repositories } from '@service/api/Repositories';
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { UserRepository } from "@api/repositories/UserRepository";
import { OnlineQueryParametersInterface } from "@api/repositories/interfaces/OnlineQueryParametersInterface";
import { EventBus } from "@common/EventBus";
import { OnlineActivityParam } from "@service/store/types/OnlineActivityParam";
import {addItems, getTake, removeItems} from "@service/store/online-users/OnlineCountersListHelper";
import {filterObjectKeys} from "@common/ObjectsHelper";

export const actions: ActionTree<OnlineUsersState, RootState> = {
    startTracking({state, dispatch}) {
        if (!state.needCounters) {
            return;
        }

        dispatch('update');

        state.updateIntervalId = window.setInterval(() => {
            dispatch('update');
        }, 30000);
    },
    update({state, dispatch, commit }) {

        const query: OnlineQueryParametersInterface[] = [];

        let activities = Object.keys(state.activities);
        activities.forEach(activityName => {
            query.push({
                id: activityName,
                count: true,
                take: getTake(state.activities[activityName])
            })
        })

        const watchers = Object.keys(state.watches);
        watchers.forEach(watch => {
            query.push({
                id: watch,
                count: true,
                take: getTake(state.watches[watch])
            })
        })

        const activity = activities.concat(['general']);

        dispatch('fetchCounters', { query, activity }).then((data) => {

            commit('setCounters', data || {});

            EventBus.$emit('onlineUsers/generalCounterUpdated');
        });
    },
    async fetchCounters({ dispatch }, data) {
        if (!document.hidden) {
            try {
                return await (repositories.get(RepositoryFabric.USER) as UserRepository).online(data.query, data.activity)
            } catch (e) {
                dispatch('reportError', e, {root: true});
            }
        }
    },
    stopTracking({state}) {
        state.updateIntervalId && clearInterval(state.updateIntervalId);
    },
    addActivity({state, commit}, activity: OnlineActivityParam | string) {
        commit('setActivities', addItems(state.activities, [activity]));
    },
    removeActivity({state, commit}, activity: OnlineActivityParam | string) {
        commit('setActivities', removeItems(state.activities, [activity]));
    },
    addWatches({state, commit}, watches: OnlineActivityParam[] | string[]) {
        commit('setWatches', addItems(state.watches, watches));
    },
    removeWatches({state, commit}, watches: OnlineActivityParam[] | string[]) {
        commit('setWatches', addItems(state.watches, watches));

        const counters = filterObjectKeys(state.counters, [...Object.keys(state.activities), ...Object.keys(state.watches)]);
        commit('setCounters', counters || {});
    },
    clearWatches({commit}) {
        commit('clearWatches');
    },
    setNeedCounters({commit}, value: boolean) {
        commit('setNeedCounters', value);
    }
};